import { PermissionsBaseModel } from '@fluxonos/features/user/models/permissions-base.model';
import { CustomerOperatorDevicePermissionsEnum } from '@fluxonos/fluxonos-dto';

/**
 * Works with both sources: the global permission list (/user/permissions)
 * and the per-device `permissions` field of CustomerOperatorDeviceDto.
 */
export class PermissionsOperatorDeviceModel extends PermissionsBaseModel {
  public get canView(): boolean {
    const permissions = [CustomerOperatorDevicePermissionsEnum.VIEW__FLUXONOS__CUSTOMER__OPERATOR_DEVICE];
    return this.checkPermissions(permissions);
  }

  public get canChange(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [CustomerOperatorDevicePermissionsEnum.CHANGE__FLUXONOS__CUSTOMER__OPERATOR_DEVICE];
    return this.checkPermissions(permissions);
  }

  public get canAdd(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [CustomerOperatorDevicePermissionsEnum.ADD__FLUXONOS__CUSTOMER__OPERATOR_DEVICE];
    return this.checkPermissions(permissions);
  }

  public get canDelete(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [CustomerOperatorDevicePermissionsEnum.DELETE__FLUXONOS__CUSTOMER__OPERATOR_DEVICE];
    return this.checkPermissions(permissions);
  }

  public get canTerminal(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [CustomerOperatorDevicePermissionsEnum.TERMINAL__FLUXONOS__CUSTOMER__OPERATOR_DEVICE];
    return this.checkPermissions(permissions);
  }

  public get canLogs(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [CustomerOperatorDevicePermissionsEnum.LOGS__FLUXONOS__CUSTOMER__OPERATOR_DEVICE];
    return this.checkPermissions(permissions);
  }

  public get isAdmin(): boolean {
    return this.canView && this.canChange && this.canAdd && this.canDelete;
  }
}